import { Reducer } from 'redux';
import { EstadoOrigemState, EstadoOrigemTypes } from './types';

const INITIAL_STATE: EstadoOrigemState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<EstadoOrigemState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EstadoOrigemTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EstadoOrigemTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case EstadoOrigemTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case EstadoOrigemTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
